import { createApp } from "vue";
import App from "./App.vue";
const app = createApp(App);

import router from "./router";
app.use(router);

import '@/assets/css/public.css'
import '@/assets/css/sideCompents.scss'
import '@/assets/css/saveFileDom.scss'

// ElementPlus
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import '@/assets/css/element-plus.scss'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
import zhCn from 'element-plus/es/locale/lang/zh-cn'

app.use(ElementPlus, {
  locale: zhCn,
})

// pinia
import { createPinia } from 'pinia'
const pinia = createPinia()
app.use(pinia)

// 注册工具方法
import custom from "@/utils/custom";
Object.keys(custom).forEach((key) => {
  app.config.globalProperties["$" + key] = custom[key]
});

// 注册全局组件
import registerGlobalComponents from './components'
registerGlobalComponents(app)


app.mount("#app");
